import React from 'react'
import cn from 'classnames'

import './Modal.less'

const { Component, createRef } = React

type ModalProps = {
  open: boolean
  onClose?: () => void
  onKeyDown?: (e: KeyboardEvent) => void
  className?: string
  children?: React.ReactNode
}

class Modal extends Component<ModalProps> {
  dialogRef = createRef<HTMLDialogElement>()

  handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault()
      e.stopPropagation()
      this.props.onClose?.()
    }
    this.props.onKeyDown?.(e)
  }

  componentDidMount() {
    this.dialogRef.current?.addEventListener('keydown', this.handleKeyDown)
    if (this.props.open) {
      const dialog = this.dialogRef.current
      if (dialog && !dialog.open) dialog.showModal()
    }
  }

  componentWillUnmount() {
    this.dialogRef.current?.removeEventListener('keydown', this.handleKeyDown)
  }

  componentDidUpdate(prevProps: ModalProps) {
    const dialog = this.dialogRef.current
    if (!dialog) return

    if (!prevProps.open && this.props.open) {
      if (!dialog.open) dialog.showModal()
    } else if (prevProps.open && !this.props.open) {
      if (dialog.open) dialog.close()
    }
  }

  render() {
    const { className, children, onClose } = this.props
    return (
      <dialog
        className={cn('modal-dialog', className)}
        ref={this.dialogRef}
        onClose={onClose}
      >
        {children}
      </dialog>
    )
  }
}

export default Modal
